export default __webpack_public_path__ + "static/media/ritik (1).da62370c.jpg";